export const ROLES = {
  ADMIN: 1,
  OPERATIONS: 2,
  KIOSK: 3,
};